export default "__VITE_ASSET__CepU_G87__"